import src from "IMAGE";
export default { src, width: 138, height: 115, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
